export default {
  message: { //俄语（
    "strid1": "Авторизоваться",
    "strid2": "Объявление",
    "strid3": "Больше",
    "strid4": "Штрафное расследование",
    "strid5": "Запрос отчета",
    "strid6": "Объявление о штрафе",
    "strid7": "Наука о безопасности",
    "strid8": "Штрафные правила",
    "strid9": "Сообщить время",
    "strid10": "Пожаловаться на игрока",
    "strid11": "Сообщить о причине",
    "strid12": "Сообщить результат",
    "strid13": "Принято",
    "strid14": "Нарушение",
    "strid15": "Штрафное время",
    "strid16": "Причина штрафа",
    "strid17": "Время разблокировки",
    "strid18": "Обращение",
    "strid19": "Обратился",
    "strid20": "Проверка",
    "strid21": "Апелляция отклонена",
    "strid22": "Результат апелляции",
    "strid23": "Обращение принято",
    "strid24": "незамедлительный",
    "strid25": "Форма обращения",
    "strid26": "Возможные причины наказания",
    "strid27": "Адрес загрузки видео / изображения / плагина",
    "strid28": "Описание",
    "strid29": "система самообслуживания",
    "strid30": "Никнеймы",
    "strid31": "AccountID",
    "strid32": "Уровень",
    "strid33": "Ранг",
    "strid34": "Продолжительность игры",
    "strid35": "Модель телефона",
    "strid36": "Почтовый ящик",
    "strid37": "Привязка AccountID （google ， fb или vk）",
    "strid38": "Перед подачей апелляции вам необходимо указать данные своей учетной записи и контактную информацию, чтобы мы могли связаться с вами.",
    "strid39": "Мой аккаунт украли.",
    "strid40": "Я не жульничал, мой аккаунт использовал только я.",
    "strid41": "Я признаю, что обманул, и больше не буду этого делать.",
    "strid42": "Пожалуйста, введите ",
    "strid43": "Связаться со службой поддержки клиентов",
    "strid44": 'Я знаю',
    "strid45": 'Нет',
    "strid46": 'Пожалуйста, заполните форму',

  }
}

